import { CanDeactivateFn, Router } from '@angular/router';

import { ROUTER_CONSTANTS } from '../../../common/constants/router.constants';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { BaseNavigateAway } from '../../../common/components/molecules/base-navigate-away/base-navigate-away';

export const CanDeactivateGuard: CanDeactivateFn<BaseNavigateAway> = (
  component: BaseNavigateAway,
) => {
  if (component.isFormDirty) {
    const router = inject(Router);
    component.openModal();
    return component.subject.asObservable().pipe(
      map((resp) => {
        if (resp) {
          return true;
        }
        if (!location.href.includes(ROUTER_CONSTANTS.createCase)) {
          router.navigate([ROUTER_CONSTANTS.createCase]);
        }
        return false;
      }),
    );
  } else {
    return true;
  }
};
